<template>
  <div class="ll-title-divider">
    <div class="ll-title-divider__title-line">
      <p
        v-if="title"
        class="ll-title-divider__title"
      >
        {{ title }}
      </p>
      <p
        v-if="subtitle"
        class="ll-title-divider__subtitle"
      >
        {{ subtitle }}
      </p>
    </div>
    <slot />
  </div>
</template>
<script>
export default {
  name: "LlTitleDivider",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-title-divider.scss";
</style>